/**
 * Convert kebab-case object keys to camelCase recursively.
 * The backend uses kebab-case (e.g., `agent-id`); the frontend uses camelCase.
 */
function kebabToCamel(str: string): string {
  return str.replace(/-([a-z0-9])/g, (_, ch) => ch.toUpperCase());
}

export function normalizeKeys<T>(obj: unknown): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => normalizeKeys(item)) as unknown as T;
  }
  if (obj !== null && typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
      result[kebabToCamel(key)] = normalizeKeys(value);
    }
    return result as T;
  }
  return obj as T;
}
